import React, { FC } from 'react';
import { ApprovalModalValidationFieldsProps } from './ApprovalModalValidationFieldsProps';
import { Stack } from '@mui/material';
import SkappaCompleteSelect from '../SkappaCompleteSelect';
import Text from '@ingka/text';
import useTranslation from '../../hooks/useTranslation';
import TextArea from '@ingka/text-area';

const ApprovalModalValidationFields: FC<ApprovalModalValidationFieldsProps> = ({
  validationComment,
  setValidationComment,
  validation,
  setValidation,
  subPortfolio,
  setSubPortfolio,
}) => {
  const t = useTranslation();
  const subPortfolioOptions = t('ppm.subportfolios') as unknown as {
    [key: string]: string;
  };
  return (
    <Stack>
      <Stack>
        <Text style={{ fontWeight: '700' }}>{'Validation'}</Text>
        <SkappaCompleteSelect
          value={validation}
          label={''}
          id={`validation-by-select`}
          onChange={setValidation}
          options={t('ppm.validations') as unknown as { [key: string]: string }}
        />
      </Stack>

      <Stack mt={2}>
        <Text style={{ fontWeight: '700' }}>{'Validation Comment'}</Text>
        <TextArea
          label={''}
          value={validationComment}
          onChange={(e) => {
            setValidationComment(e.target.value);
          }}
        />
      </Stack>

      <Stack mt={2}>
        <Text style={{ fontWeight: '700' }}>
          {t('ppm.columns.subPortfolio')}
        </Text>
        <SkappaCompleteSelect
          value={subPortfolio}
          label={''}
          id={`subportfolio-by-select`}
          onChange={setSubPortfolio}
          options={subPortfolioOptions}
        />
      </Stack>
    </Stack>
  );
};

export default ApprovalModalValidationFields;
